import { Col, Row, Card, Divider, Rate } from "antd";
import { FaArrowLeftLong } from "react-icons/fa6";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import {
  BOOKING,
  FARE,
  RATES,
  RATING,
  UPLOADS_URL,
} from "../../config/constants/api";
import { useNavigate, useParams } from "react-router-dom";
import { extractDate, extractTime } from "../../config/helpers";
import { Get } from "../../config/api/get";
import DashbordSidebar from "../../components/DashboardSidebar";
import Slider from "react-slick";
import { AiOutlineEye } from "react-icons/ai";
import Table from "react-bootstrap/Table";
// import 'bootstrap/dist/css/bootstrap.min.css';

const EditProfile = () => {
  const { id } = useParams();
  const [avgRating, setAvgRating] = useState(null);
  const token = useSelector((state) => state.user.userToken);
  const [latestRates, setLatestRates] = useState(null);
  const navigate = useNavigate();
  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);
  const slider1 = useRef(null);
  const slider2 = useRef(null);
  const [details, setDetails] = useState(null);
  const [carDetails, setCarDetails] = useState(null);
  const [pricing, setPricing] = useState(null);
  const [latestFares, setLatestFares] = useState(null);
  const [images, setImages] = useState(null);
  // const getPerMileRate = (serviceType) => {
  //   if (latestFares) {
  //     let service = latestFares.find((fare) => fare._id === serviceType);
  //     return service?.fare;
  //   }
  // };
  const getPerMileRate = (serviceType) => {
    if (latestFares && details) {
      let service = latestFares.find((fare) => fare._id.serviceType === serviceType && fare._id.passengerCapacity === details?.passengerCapacity);
      return service?.fare;
    }
  };
  const getBookingDetails = async () => {
    Get(BOOKING.getbooking + id, token)
      .then((response) => {
        if (response?.status) {
          setDetails(response?.data?.booking);
          setCarDetails(response?.data?.car);
          setImages([
            response?.data?.car?.image,
            ...response?.data?.car?.gallery,
          ]);
        }
      })
      .catch((err) => {
        console.log("error", err);
      });
  };
  useEffect(() => {
    if (!id) {
      navigate(-1);
    } else {
      getBookingDetails();
      getAllLatestFares();
      getAllLatestRates();
      getChauffeurRatings();
    }
  }, []);

  // const getHourlyRate = (serviceType) => {
  //   let capitalizedServiceType =
  //     serviceType.charAt(0).toUpperCase() + serviceType.slice(1).toLowerCase();
  //   if (latestRates) {
  //     let rate = latestRates.find(
  //       (rate) => rate._id === capitalizedServiceType
  //     );
  //     return rate?.rate;
  //   }
  // };
  const getHourlyRate = (serviceType) => {
    // let capitalizedServiceType = serviceType.charAt(0).toUpperCase() + serviceType.slice(1).toLowerCase();
    if (latestRates && details) {
      let rate = latestRates.find((rate) => rate._id.serviceType === serviceType && rate._id.passengerCapacity === details?.passengerCapacity);
      return rate?.rate;
    }
  };
  const getRushHoursRate = (serviceType) => {
    if (latestRates) {
      let rate = latestRates.find((rate) => rate._id.serviceType === serviceType);
      return rate?.rate * rate?.rushHourMultiple;
    }
  };
  // const getRushHoursRate = (serviceType) => {
  //   if (latestRates) {
  //     let rate = latestRates.find((rate) => rate._id === serviceType);
  //     return rate?.rushHourRate
  //   }
  // };

  const getAllLatestFares = () => {
    Get(FARE.getAllLatestFares, token)
      .then((response) => {
        if (response?.status) {
          setLatestFares(response?.data?.latestFares);
          setPricing(response?.data?.pricing);
        }
      })
      .catch((err) => {
        console.log("error", err);
      });
  };
  const getAllLatestRates = () => {
    Get(RATES.getAllLatestRates, token)
      .then((response) => {
        if (response?.status) {
          setLatestRates(response?.data);
        }
      })
      .catch((err) => {
        console.log("error", err);
      });
  };
  const getTotalBeforeGratuity = () => {
    if (details) {
      if (details?.type === "Subscription") {
        return (
          getHourlyRate(details?.serviceType) *
            (details?.finalDuration > 8 ? details?.finalDuration - 8 : 0) +
          (details?.rushHours
            ? details?.rushHours * getRushHoursRate(details?.serviceType) -
              getHourlyRate(details?.serviceType) * details?.rushHours
            : 0) +
          details?.finalMileage *
            getPerMileRate(
              details?.serviceType
            )
        );
      } else {
        return (
          getHourlyRate(details?.serviceType) * details?.finalDuration +
          (details?.rushHours
            ? details?.rushHours * getRushHoursRate(details?.serviceType) -
              getHourlyRate(details?.serviceType) * details?.rushHours
            : 0) +
          details?.finalMileage *
            getPerMileRate(
              details?.serviceType
            )
        );
      }
    } else {
      return;
    }
  };
  useEffect(() => {
    setNav1(slider1.current);
    setNav2(slider2.current);
  }, [slider1?.current, slider2?.current, images]);

  const sliderSettings = {
    arrows: false,
    // other settings...
  };
  const sliderSettings2 = {
    // arrows: false,
    // style: {
    //   margin: "20px",
    // },
  };

  const getChauffeurRatings = async () => {
    if (details?.chauffeur?._id) {
      Get(RATING.getChauffeurRatings + details?.chauffeur?._id, token)
        .then((response) => {
          if (response?.status) {
            setAvgRating(response?.data?.averageRating);
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    }
  };
  function formatDuration(totalDuration) {
    if (totalDuration) {
      const totalMinutes = Math.round(totalDuration * 60);
      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;

      if (hours === 0) {
        return `${minutes} mins`;
      } else if (minutes === 0) {
        return `${hours} hour${hours > 1 ? "s" : ""}`;
      } else {
        return `${hours} hour${hours > 1 ? "s" : ""} ${minutes} mins`;
      }
    } else {
      return 0;
    }
  }

  return (
    <div className="shop-page bg-white py-6">
      <Row style={{ width: "100%", justifyContent: "center" }}>
        <Col xs={23} md={21}>
          <div className="shop-page-main">
            <Row gutter={[16, 16]}>
              <Col xs={24} md={24} lg={24} xl={24}>
                <div className="my-account-profile">
                  <section className="side-menu-parent">
                    <DashbordSidebar />
                    <div className="about-us-section">
                      <div className="profile-information-wrapper">
                        <FaArrowLeftLong
                          className="arrow cursor-pointer"
                          onClick={() => navigate(-1)}
                        />
                        <h3 className="text-5xl max-desktop:text-4xl font-goldman text-center py-4">
                          Chauffeur Booking Details
                        </h3>
                      </div>
                      {details && (
                        <div className="bg-parent relative">
                          <Row justify="center">
                            <Col xs={24} md={24} xl={24}>
                              <Card>
                                <div className="boxDetails">
                                  {avgRating && (
                                    <div className="flex justify-end items-center">
                                      <div className="view-rating">
                                        <h5 className="font-euclid text-lg max-xl:text-sm text-black font-bold mb-1 p-2">
                                          Overall Rating
                                        </h5>
                                        <span>
                                          <Rate
                                            disabled
                                            defaultValue={avgRating}
                                          />
                                        </span>
                                      </div>
                                    </div>
                                  )}
                                  <Row
                                    justify="start"
                                    className="my-4"
                                    gutter={[16, 16]}
                                  >
                                    <Col xs={24} md={24} lg={20} xxl={12}>
                                      <div className="bg-[#EBEBEB] rounded-lg flex max-sm:flex-col items-center justify-between xl:p-3 p-3">
                                        <div className="flex flex-col items-start justify-center max-sm:order-1">
                                          <h5 className="font-euclid text-sm max-xl:text-xs text-black font-bold mb-1">
                                            {extractDate(details?.date)} at{" "}
                                            {extractTime(details?.time)} (PDT)
                                          </h5>
                                          <p className="font-euclid text-sm max-xl:text-xs text-gray-500 font-normal mb-2 sm:mr-4">
                                            {details?.pickupLocation?.address}{" "}
                                            To{" "}
                                            {details?.dropoffLocation?.address
                                              ? details?.dropoffLocation
                                                  ?.address
                                              : "-"}
                                          </p>
                                          <p className="font-euclid text-sm max-xl:text-xs text-gray-500 font-normal mb-2 sm:mr-4">
                                            Total mileage:{" "}
                                            {details?.finalMileage
                                              ? details?.finalMileage.toFixed(2)
                                              : details?.initialMileage.toFixed(
                                                  2
                                                )}{" "}
                                            miles
                                          </p>
                                          {details?.type !== "Subscription" ? (
                                            <h5 className="font-euclid text-lg max-xl:text-sm text-black font-bold mb-1">
                                              $
                                              {(
                                                getHourlyRate(
                                                  details?.serviceType
                                                ) * details?.finalDuration
                                              ).toFixed(2)}
                                              /
                                              {details?.finalDuration.toFixed(
                                                2
                                              )}
                                              hrs
                                            </h5>
                                          ) : (
                                            <>
                                              {details?.finalDuration > 8 ? (
                                                <h5 className="font-euclid text-lg max-xl:text-sm text-black font-bold mb-1">
                                                  Extra Hour Charges $
                                                  {getHourlyRate(
                                                    details?.serviceType
                                                  ) *
                                                    (details?.finalDuration -
                                                      8)}{" "}
                                                  / {details?.finalDuration - 8}{" "}
                                                  hrs
                                                </h5>
                                              ) : (
                                                <></>
                                              )}
                                            </>
                                          )}
                                        </div>
                                      </div>
                                    </Col>
                                    <Col xs={24} md={24} lg={20} xxl={12}>
                                      <div className="bg-[#EBEBEB] rounded-lg flex flex-col items-start justify-center sm:p-3 p-3 ">
                                        <h5 className="font-euclid text-lg max-xl:text-sm text-black font-bold mb-1">
                                          Chauffeur Details
                                        </h5>
                                        <div className="flex justify-center  my-2 resp-flex-none">
                                          <div className="flex flex-col items-start lg:mr-36 mr-12">
                                            <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                                              Name
                                            </h5>
                                            <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-2">
                                              {details?.chauffeur?.firstName}{" "}
                                              {details?.chauffeur?.lastName}
                                            </p>
                                            {/* <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                                            Contact
                                          </h5>
                                          <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-3">
                                            {details?.chauffeur?.phone}
                                          </p> */}
                                          </div>
                                          <img
                                            src={
                                              UPLOADS_URL +
                                              details?.chauffeur?.image
                                            }
                                            alt="chauffeur"
                                            className="max-sm:order-0"
                                            style={{
                                              width: "100px",
                                              height: "100px",
                                              borderRadius: "100%",
                                              objectFit: "cover",
                                              objectPosition: "center",
                                            }}
                                          />
                                        </div>
                                      </div>
                                    </Col>
                                  </Row>

                                  <Row className="my-3 justify-normal">
                                    <Col xs={24} md={24} lg={24} xxl={24}>
                                 
                                      <h4 className="font-tavi text-[20px] text-black my-2">
                                        {details?.dropoffLocation
                                          ? "Distance Service in Manhattan"
                                          : "Hourly Service in Manhattan"}
                                      </h4>
                                      <Table
                                        responsive
                                        striped
                                        bordered
                                        hover
                                        className="custom-table "
                                      >
                                        <thead>
                                          <tr>
                                            <th>Vehicle Type</th>
                                            <th>Final Booking Duration</th>
                                            <th>Final Mileage</th>
                                            <th>Hourly Rate: $
                                              {getHourlyRate(
                                                details?.serviceType
                                              )}{" "}
                                              per hour</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr>
                                            <td>{details?.serviceType} Luxury</td>
                                            <td> {formatDuration(
                                            details?.finalDuration
                                          )}</td>
                                            <td>  {details?.finalMileage} miles</td>
                                            <td>
                                            Total for{" "}
                                              {formatDuration(
                                                details?.finalDuration
                                              )}{" "}
                                              :{" "}
                                              {formatDuration(
                                                details?.finalDuration
                                              )}{" "}
                                              × $
                                              {getHourlyRate(
                                                details?.serviceType
                                              )}
                                              /hour = $
                                              {(
                                                getHourlyRate(
                                                  details?.serviceType
                                                ) * details?.finalDuration
                                              ).toFixed(2)}
                                              /
                                              {details?.finalDuration.toFixed(
                                                2
                                              )}
                                              hrs
                                            </td>
                                          </tr>
                                        </tbody>

                                        <thead>
                                          <tr>
                                            <th>
                                              Mileage Fee:  {details?.serviceType} Luxury: ${getPerMileRate(
                                                details?.serviceType
                                              )}{" "}
                                           
                                              
                                              per mile
                                            </th>
                                            <th>Booking Fee</th>
                                            <th>Service Fee</th>
                                            <th>Total before Gratuity</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr>
                                            <td>
                                            Total for {details?.finalMileage}{" "}
                                              miles : {details?.finalMileage}{" "}
                                              miles × ${" "}
                                              {getPerMileRate(
                                                details?.serviceType
                                              )}
                                          
                                              /mile = $
                                              {(
                                                details?.finalMileage *
                                                getPerMileRate(
                                                  details?.serviceType
                                                )
                                              ).toFixed(2)}
                                          
                                            </td>
                                            <td>${pricing?.bookingFee}</td>
                                            <td>${pricing?.serviceFee}</td>
                                            <td>
                                            {details?.type !== "Subscription" ? (
                                            <span style={{ margin: "0 3px" }}>
                                              $
                                              {(
                                                getHourlyRate(
                                                  details?.serviceType
                                                ) * details?.finalDuration
                                              ).toFixed(2)}
                                              (hourly)
                                            </span>
                                          ) : (
                                            <span style={{ margin: "0 3px" }}>
                                              $
                                              {details?.finalDuration > 8
                                                ? (details?.finalDuration - 8) *
                                                  getHourlyRate(
                                                    details?.serviceType
                                                  )
                                                : 0}
                                              (Extra Hours Rate)
                                            </span>
                                          )}
                                          + $
                                          {(
                                            details?.finalMileage *
                                            getPerMileRate(
                                              details?.serviceType
                                            )
                                          ).toFixed(2)}
                                          (mileage) + $
                                          {details?.rushHours
                                            ? (details?.rushHours *
                                                getRushHoursRate(
                                                  details?.serviceType
                                                ) -
                                              getHourlyRate(
                                                details?.serviceType
                                              ) *
                                                details?.rushHours).toFixed(2)
                                            : 0}
                                          (Rush hour fee) = $
                                          {getTotalBeforeGratuity().toFixed(2)}
                                            </td>
                                          </tr>
                                        </tbody>

                                        <thead>
                                          <tr>
                                            <th>Gratuity</th>
                                            <th>Tolls Charges</th>
                                            <th>Surcharge</th>
                                            <th>Rush hour fee</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr>
                                            <td>20% x $
                                            {getTotalBeforeGratuity().toFixed(2)} = $
                                            {details?.gratuityAmount.toFixed(2)}</td>
                                            <td>${details?.tolls ? details?.tolls : 0}</td>
                                            <td>${details?.surcharge
                                            ? details?.surcharge
                                            : 0}</td>
                                            <td>${details?.rushHours
                                            ? (details?.rushHours *
                                                getRushHoursRate(
                                                  details?.serviceType
                                                ) -
                                              getHourlyRate(
                                                details?.serviceType
                                              ) *
                                                details?.rushHours).toFixed(2)
                                            : 0}</td>
                                          </tr>
                                        </tbody>

                                        <thead>
                                          <tr>
                                            <th colSpan={4}>Total Amount</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr>
                                            <td colSpan={4}>${details?.totalCharges.toFixed(2)}</td>
                                          </tr>
                                        </tbody>
                                      </Table>

                                    
                                    </Col>
                                  </Row>

                                  <Row justify="center">
                                    <Col md={24} xs={24}>
                                      <div className="bg-white rounded-lg  mb-12">
                                        <h3 className="font-tavi lg:text-3xl text-2xl max-sm:text-lg font-normal text-black py-4">
                                          Car Details
                                        </h3>
                                        <Row justify="left" gutter={[32, 32]}>
                                          {Array.isArray(images) &&
                                            images.length > 0 && (
                                              <Col
                                                xxl={10}
                                                xl={10}
                                                xs={24}
                                                className="customSlider sm:px-4 self-center innermultiple-slider"
                                              >
                                                <div>
                                                  <Slider
                                                    asNavFor={nav2}
                                                    ref={slider1}
                                                    {...sliderSettings}
                                                  >
                                                    {Array.isArray(images) &&
                                                      images.map(
                                                        (image, index) => {
                                                          return (
                                                            <div key={index}>
                                                              <span>
                                                                <img
                                                                  src={
                                                                    UPLOADS_URL +
                                                                    image
                                                                  }
                                                                  alt=""
                                                                  className="img-fluid"
                                                                  style={{
                                                                    width:
                                                                      "100%",
                                                                    maxHeight:
                                                                      "250px",
                                                                    objectFit:
                                                                      "cover",
                                                                    objectPosition:
                                                                      "center",
                                                                    height:
                                                                      "250px",
                                                                  }}
                                                                />
                                                              </span>
                                                            </div>
                                                          );
                                                        }
                                                      )}
                                                  </Slider>
                                                  <Slider
                                                    asNavFor={nav1}
                                                    ref={slider2}
                                                    slidesToShow={
                                                      images
                                                        ? images.length
                                                        : carDetails?.gallery
                                                            ?.length
                                                    }
                                                    swipeToSlide={true}
                                                    focusOnSelect={true}
                                                    {...sliderSettings2}
                                                  >
                                                    {Array.isArray(images) &&
                                                      images.map(
                                                        (image, index) => {
                                                          return (
                                                            <div
                                                              key={index}
                                                              className="slider-nav"
                                                            >
                                                              <span>
                                                                <img
                                                                  src={
                                                                    UPLOADS_URL +
                                                                    image
                                                                  }
                                                                  alt=""
                                                                  className="img-fluid"
                                                                  style={{
                                                                    width:
                                                                      "100%",
                                                                    height:
                                                                      "90px",
                                                                    objectFit:
                                                                      "cover",
                                                                    objectPosition:
                                                                      "center",
                                                                    maxWidth:
                                                                      "250px",
                                                                  }}
                                                                />
                                                              </span>
                                                            </div>
                                                          );
                                                        }
                                                      )}
                                                  </Slider>
                                                </div>
                                              </Col>
                                            )}
                                          <Col xxl={12} xl={14} xs={24}>
                                            <div className="flex justify-center my-4 w-full">
                                              <div className="flex flex-col items-start w-full">
                                                <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                                                  Car Brand
                                                </h5>
                                                <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                                                  {carDetails?.brand}
                                                </p>
                                                <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                                                  Car Model
                                                </h5>
                                                <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                                                  {carDetails?.model}
                                                </p>

                                                <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                                                  Service Type
                                                </h5>
                                                <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                                                  {carDetails?.serviceType}{" "}
                                                  Luxury
                                                </p>
                                              </div>
                                              <div className="flex flex-col items-start w-full">
                                                <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                                                  Car Name
                                                </h5>
                                                <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                                                  {carDetails?.name}
                                                </p>
                                                <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                                                  Car Number
                                                </h5>
                                                <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                                                  {carDetails?.carNumber}
                                                </p>
                                                <h5 className="font-euclid text-sm max-sm:text-xs text-black font-bold mb-1">
                                                  Passenger Capacity
                                                </h5>
                                                <p className="font-euclid text-sm max-sm:text-xs text-gray-500 font-normal mb-6">
                                                  {
                                                    carDetails?.passengerCapacity
                                                  }
                                                </p>
                                              </div>
                                            </div>
                                          </Col>
                                        </Row>
                                      </div>
                                    </Col>
                                  </Row>
                                  <br />
                                </div>
                              </Card>
                            </Col>
                          </Row>
                        </div>
                      )}
                    </div>
                  </section>
                </div>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default EditProfile;
